import { UsherHistory } from 'app/components/UsherHistory';

const UsherHistoryPage = () => {
  return <UsherHistory />;
};

export default UsherHistoryPage;
